import React from "react";
import { PageHeader } from "./About";
import { CTABanner } from "../components/Sections";
import { Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const articles = [
  {
    slug: "rebuild-credit-after-bankruptcy",
    title: "How to Rebuild Your Credit After Bankruptcy in 2026",
    excerpt: "Discharged your debt but watching your score recover at a snail's pace? Here's the realistic 18-month roadmap our clients use.",
    minutes: 11,
    tag: "Credit Repair",
    cover: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
  },
  {
    slug: "how-many-credit-cards",
    title: "How Many Credit Cards Should You Actually Have?",
    excerpt: "Is one card enough? Could ten cards help your score? Here's what the FICO data actually rewards.",
    minutes: 8,
    tag: "Score Building",
    cover: "https://images.unsplash.com/photo-1556742400-b5b7c5121f6f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
  },
  {
    slug: "student-loan-default",
    title: "Student Loan Default on Your Credit Report: How Long & How to Remove",
    excerpt: "Over 2.6 million borrowers fell into default last quarter. Here's exactly how long it stays — and the proven methods to remove it.",
    minutes: 9,
    tag: "Disputes",
    cover: "https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
  },
  {
    slug: "debt-collectors-sue",
    title: "When Can Debt Collectors Sue You? (And What to Do If They Do)",
    excerpt: "Collectors can sue within your state's statute of limitations — but lawsuits aren't automatic. Here's how to read the warning signs.",
    minutes: 9,
    tag: "FDCPA Rights",
    cover: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
  },
  {
    slug: "self-employed-credit",
    title: "Credit Repair for Self-Employed & Gig Workers",
    excerpt: "Freelancing or gig work? You face unique credit challenges that traditional advice ignores. Here's the 2026 guide.",
    minutes: 9,
    tag: "Credit Building",
    cover: "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
  },
  {
    slug: "summer-vacation-credit",
    title: "How Vacation Spending Can Wreck Your Credit (And How to Recover)",
    excerpt: "Summer travel puts 83% of Americans into card debt. Here's how to bounce back fast.",
    minutes: 8,
    tag: "Money Habits",
    cover: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
  }
];

const Blog = () => (
  <main>
    <PageHeader title="Credit Education" subtitle="KNOWLEDGE HUB" />

    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-knight-gold font-semibold tracking-widest text-xs mb-3">GUIDES & ARTICLES</p>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-knight-navy">Real advice from <em>credit specialists</em></h2>
          <p className="text-knight-navy/70 leading-relaxed mt-3">No fluff. No gimmicks. Practical guides to help you take real control of your credit.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <Link
              key={i}
              to="/blog"
              onClick={(e) => e.preventDefault()}
              className="card-intense group bg-white rounded-3xl border border-slate-200 overflow-hidden block"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={a.cover} alt={a.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs mb-3">
                  <span className="font-semibold text-knight-gold tracking-wider">{a.tag.toUpperCase()}</span>
                  <span className="text-knight-navy/40 flex items-center gap-1"><Clock size={12} /> {a.minutes} min read</span>
                </div>
                <h3 className="font-display font-bold text-xl text-knight-navy mb-3 leading-snug group-hover:text-knight-navy/80">{a.title}</h3>
                <p className="text-sm text-knight-navy/70 leading-relaxed mb-4">{a.excerpt}</p>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-knight-navy group-hover:text-knight-gold transition-colors">
                  Read article <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>

    <CTABanner />
  </main>
);

export default Blog;
